import {Buildings, BoundingBox, Layout, Bed} from '@phosphor-icons/react'
import {LayoutProgressBar} from '../../../features/layout/componnets/LayoutProgressBar'
import clsx from 'clsx'
import {Spinner} from 'react-bootstrap'

export const ViewOccupancyLayout = ({
  data,
  tipoData,
  loadModulesLayout,
  loadFloorsLayout,
  loadHabiationsLayout,
  selectedOptionName,
  selectedOption,
  loadBedsLayout,
  loadCampsLayout,
  isLoadingLayout,
  modules
}: {
  data: any
  modules?:any
  tipoData: string
  selectedOptionName: any
  selectedOption: any
  loadCampsLayout?: () => void
  loadModulesLayout?: (id: string, name: string) => void
  loadFloorsLayout: (id: string, name: string) => void
  loadHabiationsLayout: (id: string, name: string) => void
  loadBedsLayout: (id: string, name: string) => void
  isLoadingLayout?: boolean
}) => {
  return (
    <div className='p-6'>
      <div className='card card-custom'>
        <div className={'card-header'}>
          <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0'>
            {selectedOptionName.site && (
              <li className={clsx('breadcrumb-item', 'text-dark')}>
                <div
                  className='text-muted text-hover-primary cursor-pointer'
                  onClick={() => loadCampsLayout && loadCampsLayout()}
                >
                  {selectedOptionName.site}
                </div>
              </li>
            )}
            {selectedOptionName.camp && (
              <>
                <li className='breadcrumb-item'>
                  <span className='bullet bg-gray-400 w-5px h-2px'></span>
                </li>
                <li className={clsx('breadcrumb-item', 'text-dark')}>
                  <div
                    className='text-muted text-hover-primary cursor-pointer'
                    onClick={() =>
                      loadModulesLayout &&
                      loadModulesLayout(selectedOption.camp, selectedOptionName.camp)
                    }
                  >
                    {selectedOptionName.camp}
                  </div>
                </li>
              </>
            )}

            {selectedOptionName.mod && (
              <>
                <li className='breadcrumb-item'>
                  <span className='bullet bg-gray-400 w-5px h-2px'></span>
                </li>
                <li className={clsx('breadcrumb-item', 'text-dark')}>
                  <div
                    className='text-muted text-hover-primary cursor-pointer'
                    onClick={() => loadFloorsLayout(selectedOption.mod, selectedOptionName.mod)}
                  >
                    {selectedOptionName.mod}
                  </div>
                </li>
              </>
            )}

            {selectedOptionName.pis && (
              <>
                <li className='breadcrumb-item'>
                  <span className='bullet bg-gray-400 w-5px h-2px'></span>
                </li>
                <li className={clsx('breadcrumb-item', 'text-dark')}>
                  <div
                    className='text-muted text-hover-primary cursor-pointer'
                    onClick={() => loadHabiationsLayout(selectedOption.pis, selectedOptionName.pis)}
                  >
                    {selectedOptionName.pis}
                  </div>
                </li>
              </>
            )}

            {selectedOptionName.hbt && (
              <>
                <li className='breadcrumb-item'>
                  <span className='bullet bg-gray-400 w-5px h-2px'></span>
                </li>
                <li className={clsx('breadcrumb-item', 'text-dark')}>
                  <div
                    className='text-muted text-hover-primary cursor-pointer'
                    onClick={() => loadBedsLayout(selectedOption.hbt, selectedOptionName.hbt)}
                  >
                    {selectedOptionName.hbt}
                  </div>
                </li>
              </>
            )}

            {/*<li className='breadcrumb-item text-dark'>Fin</li>*/}
          </ul>
        </div>
        {isLoadingLayout ? (
          <div className='p-6'>
            <div className='card card-custom'>
              <div className='card-body'>
                <div
                  className='d-flex justify-content-center align-items-center mb-2'
                  // style={{height: '100px'}}
                >
                  <Spinner animation='border' />
                </div>
                <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                  Cargando
                </div>
              </div>
            </div>
          </div>
        ) : data.length > 0 ? (
          <div className='card-body'>
            {tipoData === 'CAP' && (
              <>
                {data.length > 0 && (
                  <div className='py-5 d-flex flex-wrap'>
                    <h4 className='d-flex align-items-center'>
                      <BoundingBox className='me-2 text-muted' size={32} weight='duotone' />{' '}
                      CAMPAMENTOS
                    </h4>
                  </div>
                )}
                <div className={'d-flex flex-wrap'}>
                  {data.map((campa: any, index: any) => (
                    <div
                      key={`camp-${index}`}
                      className='card border card-xl-stretch min-w-350px mx-3 cursor-pointer'
                      onClick={() =>
                        loadModulesLayout &&
                        loadModulesLayout(campa.CampamentoId, campa.CampamentoNombre)
                      }
                    >
                      <div className='card-header border-0 py-5 gap-4'>
                        <h3 className='card-title align-items-start flex-column'>
                          <span className='card-label fw-bold fs-3 mb-1'>
                            {campa.CampamentoNombre}
                          </span>
                          <LayoutProgressBar campa={campa}></LayoutProgressBar>
                        </h3>
                        <div className='card-toolbar'>
                          <BoundingBox
                            className='me-2 text-muted mt-2'
                            size={32}
                            weight='duotone'
                          />
                        </div>
                      </div>
                      <div>
                        <div className='card-p pt-5 bg-body flex-grow-1'>
                          <div className='row g-0'>
                            <div className='col mr-8'>
                              <div className='fs-7 text-muted fw-semibold'>Módulos</div>
                              <div className='d-flex align-items-center'>
                                <div className='fs-4 fw-bold'>{campa.TotalModulos}</div>
                              </div>
                            </div>
                            <div className='col'>
                              <div className='fs-7 text-muted fw-semibold'>Habitaciones</div>
                              <div className='fs-4 fw-bold'>{campa.TotalHabitaciones}</div>
                            </div>
                          </div>
                          <div className='row g-0 mt-8'>
                            <div className='col mr-8'>
                              <div className='fs-7 text-muted fw-semibold'>Camas ocupadas</div>
                              <div className='fs-4 fw-bold'>{campa.TotalCamasOCU}</div>
                            </div>
                            <div className='col'>
                              <div className='fs-7 text-muted fw-semibold'>Camas bloqueadas</div>
                              <div className='d-flex align-items-center'>
                                <div className='fs-4 fw-bold'>{campa.TotalCamasBLO}</div>
                              </div>
                            </div>
                          </div>
                          <div className='row g-0 mt-8'>
                            <div className='col mr-8'>
                              <div className='fs-7 text-muted fw-semibold'>Camas disponibles</div>
                              <div className='fs-4 fw-bold'>{campa.TotalCamasDIS}</div>
                            </div>
                            <div className='col mr-8'>
                              <div className='fs-7 text-muted fw-semibold'>Camas reservadas</div>
                              <div className='fs-4 fw-bold'>{campa.TotalCamasRES}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {tipoData === 'MOD' && (
              <>
                {data.length > 0 && (
                  <div className='py-5 d-flex flex-wrap'>
                    <h4 className='d-flex align-items-center'>
                      <Buildings className='me-2 text-muted' size={32} weight='duotone' /> MODULOS
                    </h4>
                  </div>
                )}
                <div className={'d-flex flex-wrap'}>
                  {data.map((campa: any, index: any) => (
                    <div
                      key={`camp-${index}`}
                      className='card border card-xl-stretch min-w-350px mx-3 cursor-pointer'
                      onClick={() => loadFloorsLayout(campa.ModuloId, campa.NomenclaturaModulo)}
                    >
                      <div className='card-header border-0 py-5 gap-4'>
                        <h3 className='card-title align-items-start flex-column'>
                          <span className='card-label fw-bold fs-3 mb-1'>
                            {campa.NomenclaturaModulo}
                          </span>
                          <LayoutProgressBar campa={campa} mods={modules}></LayoutProgressBar>
                        </h3>
                        <div className='card-toolbar'>
                          <Buildings className='me-2 text-muted mt-2' size={24} weight='duotone' />
                        </div>
                      </div>
                      <div>
                        <div className='card-p pt-5 bg-body flex-grow-1'>
                          <div className='row g-0'>
                            <div className='col'>
                              <div className='fs-7 text-muted fw-semibold'>Habitaciones</div>
                              <div className='fs-4 fw-bold'>{campa.TotalHabitaciones}</div>
                            </div>
                            <div className='col mr-8'>
                              <div className='fs-7 text-muted fw-semibold'>Camas disponibles</div>
                              <div className='fs-4 fw-bold'>{campa.TotalCamasDIS}</div>
                            </div>
                          </div>
                          <div className='row g-0 mt-8'>
                            <div className='col mr-8'>
                              <div className='fs-7 text-muted fw-semibold'>Camas ocupadas</div>
                              <div className='fs-4 fw-bold'>{campa.TotalCamasOCU}</div>
                            </div>
                            <div className='col'>
                              <div className='fs-7 text-muted fw-semibold'>Camas bloqueadas</div>
                              <div className='d-flex align-items-center'>
                                <div className='fs-4 fw-bold'>{campa.TotalCamasBLO}</div>
                              </div>
                            </div>
                          </div>
                          <div className='row g-0 mt-8'>
                            <div className='col mr-8'>
                              <div className='fs-7 text-muted fw-semibold'>Camas reservadas</div>
                              <div className='fs-4 fw-bold'>{campa.TotalCamasRES}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {tipoData === 'PIS' && (
              <>
                {data.length > 0 && (
                  <div className='py-5 d-flex flex-wrap'>
                    <h4 className='d-flex align-items-center'>
                      <Layout className='me-2 text-muted' size={32} weight='duotone' /> PISOS
                    </h4>
                  </div>
                )}
                <div className={'d-flex flex-wrap'}>
                  {data.map((campa: any, index: any) => (
                    <div
                      key={`camp-${index}`}
                      onClick={() => loadHabiationsLayout(campa.PisoId, campa.PisoNombre)}
                      className='card border card-xl-stretch min-w-350px mx-3 cursor-pointer'
                    >
                      <div className='card-header border-0 py-5 gap-4'>
                        <h3 className='card-title align-items-start flex-column'>
                          <span className='card-label fw-bold fs-3 mb-1'>{campa.PisoNombre}</span>
                          <LayoutProgressBar campa={campa}></LayoutProgressBar>
                        </h3>
                        <div className='card-toolbar'>
                          <Layout className='me-2 text-muted mt-2' size={24} weight='duotone' />
                        </div>
                      </div>
                      <div>
                        <div className='card-p pt-5 bg-body flex-grow-1'>
                          <div className='row g-0'>
                            <div className='col'>
                              <div className='fs-7 text-muted fw-semibold'>Habitaciones</div>
                              <div className='fs-4 fw-bold'>{campa.TotalHabitaciones}</div>
                            </div>
                            <div className='col mr-8'>
                              <div className='fs-7 text-muted fw-semibold'>Camas disponibles</div>
                              <div className='fs-4 fw-bold'>{campa.TotalCamasDIS}</div>
                            </div>
                          </div>
                          <div className='row g-0 mt-8'>
                            <div className='col mr-8'>
                              <div className='fs-7 text-muted fw-semibold'>Camas ocupadas</div>
                              <div className='fs-4 fw-bold'>{campa.TotalCamasOCU}</div>
                            </div>
                            <div className='col'>
                              <div className='fs-7 text-muted fw-semibold'>Camas bloqueadas</div>
                              <div className='d-flex align-items-center'>
                                <div className='fs-4 fw-bold'>{campa.TotalCamasBLO}</div>
                              </div>
                            </div>
                          </div>
                          <div className='row g-0 mt-8'>
                            <div className='col mr-8'>
                              <div className='fs-7 text-muted fw-semibold'>Camas reservadas</div>
                              <div className='fs-4 fw-bold'>{campa.TotalCamasRES}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {tipoData === 'HAB' && (
              <>
                {data.length > 0 && (
                  <div className='py-5 d-flex flex-wrap'>
                    <h4 className='d-flex align-items-center'>
                      <Layout className='me-2 text-muted' size={32} weight='duotone' /> HABITACIONES
                    </h4>
                  </div>
                )}
                <div className={'d-flex flex-wrap'}>
                  {data.map((campa: any, index: any) => (
                    <div
                      key={`hbt-${index}`}
                      onClick={() =>
                        loadBedsLayout(campa.HabitacionId, campa.NomenclaturaHabitacion)
                      }
                      className='card border card-xl-stretch min-w-350px mx-3 cursor-pointer'
                    >
                      <div className='card-header border-0 py-5 gap-4'>
                        <h3 className='card-title align-items-start flex-column'>
                          <span className='card-label fw-bold fs-3 mb-1'>
                            {campa.NomenclaturaHabitacion}
                          </span>
                          <LayoutProgressBar campa={campa}></LayoutProgressBar>
                        </h3>
                        <div className='card-toolbar'>
                          <Layout className='me-2 text-muted mt-2' size={24} weight='duotone' />
                        </div>
                      </div>
                      <div>
                        <div className='card-p pt-5 bg-body flex-grow-1'>
                          <div className='row g-0'>
                            <div className='col'>
                              <div className='fs-7 text-muted fw-semibold'>Habitaciones</div>
                              <div className='fs-4 fw-bold'>{campa.TotalHabitaciones}</div>
                            </div>
                            <div className='col mr-8'>
                              <div className='fs-7 text-muted fw-semibold'>Camas disponibles</div>
                              <div className='fs-4 fw-bold'>{campa.TotalCamasDIS}</div>
                            </div>
                          </div>
                          <div className='row g-0 mt-8'>
                            <div className='col mr-8'>
                              <div className='fs-7 text-muted fw-semibold'>Camas ocupadas</div>
                              <div className='fs-4 fw-bold'>{campa.TotalCamasOCU}</div>
                            </div>
                            <div className='col'>
                              <div className='fs-7 text-muted fw-semibold'>Camas bloqueadas</div>
                              <div className='d-flex align-items-center'>
                                <div className='fs-4 fw-bold'>{campa.TotalCamasBLO}</div>
                              </div>
                            </div>
                          </div>
                          <div className='row g-0 mt-8'>
                            <div className='col mr-8'>
                              <div className='fs-7 text-muted fw-semibold'>Camas reservadas</div>
                              <div className='fs-4 fw-bold'>{campa.TotalCamasRES}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {tipoData === 'CAM' && (
              <>
                {data.length > 0 && (
                  <div className='py-5 d-flex flex-wrap'>
                    <h4 className='d-flex align-items-center'>
                      <Layout className='me-2 text-muted' size={32} weight='duotone' /> CAMAS
                    </h4>
                  </div>
                )}
                <div className={'d-flex flex-wrap'}>
                  {data.map((campa: any, index: any) => (
                    <div
                      key={`hbt-${index}`}
                      className='card border card-xl-stretch min-w-350px mx-3'
                      style={{backgroundColor: campa.ColorFondo}}
                    >
                      <div
                        className='card-header border-0 py-5 gap-4'
                        style={{backgroundColor: campa.ColorFondo, color: campa.ColorFuente}}
                      >
                        <h3 className='card-title align-items-start flex-column'>
                          <span
                            className='card-label fw-bold fs-3 mb-1'
                            style={{color: campa.ColorFuente}}
                          >
                            {campa.NomenclaturaCama}
                          </span>
                          <span
                            className={clsx('fw-bold fs-6', {'fs-7': campa.Estado === 'OCU'})}
                            style={{color: campa.ColorFuente}}
                          >
                            Cama Caliente Virtual: {campa.CamaCaliente ? 'SI' : 'NO'}
                          </span>
                          <div
                            className={clsx('d-flex', {
                              'mb-2': campa.Estado !== 'OCU',
                            })}
                          >
                            <span
                              className={clsx('fw-bold fs-6', {'fs-7': campa.Estado === 'OCU'})}
                              style={{color: campa.ColorFuente}}
                            >
                              {campa.Estado === 'DIS' && 'Disponible'}
                              {campa.Estado === 'OCU' && 'Ocupado'}
                              {campa.Estado === 'BLO' && 'Bloqueado'}
                              {campa.Estado === 'RES' && 'Reservado'}
                            </span>
                          </div>
                          {campa.Estado === 'OCU' && (
                            <div>
                              <div className='fw-bold fs-7 ' style={{color: campa.ColorFuente}}>
                                Ruc Contratista: {campa.RucEmpresaContratante}
                              </div>
                              <div className='fw-bold fs-7 ' style={{color: campa.ColorFuente}}>
                                Empresa Contratista: {campa.RazonSocialContratante}
                              </div>
                              <div className='fw-bold fs-7 ' style={{color: campa.ColorFuente}}>
                                Nro Doc: {campa.NroDocumento}
                              </div>
                              <div className='fw-bold fs-7 ' style={{color: campa.ColorFuente}}>
                                Huésped: {campa.NombresCompletos}
                              </div>
                            </div>
                          )}
                        </h3>
                        <div className='card-toolbar'>
                          <Bed
                            className='me-2 mt-2'
                            style={{color: campa.ColorFuente}}
                            size={24}
                            weight='duotone'
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        ) : (
          <div className='p-6'>
            <div className='card card-custom'>
              <div className='card-body'>
                <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                  No hay información
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
